import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11922ab8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-nosnippet": "" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Man90's Party Builder"),
  /*#__PURE__*/_createElementVNode("sup", null, "v2")
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }

import { computed } from "vue"
	import { useRoute } from "vue-router"

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  setup(__props) {

	const route = useRoute()
	const full = computed(() => "landing" === route.name)
	const logoSrc = `${process.env.VUE_APP_ASSETS_ENDPOINT}GI-logo.svg`

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    (full.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "for"))
      : _createCommentVNode("", true),
    (full.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: logoSrc,
          alt: "Genshin Impact"
        }))
      : (_openBlock(), _createElementBlock("nav", _hoisted_4, [
          _createVNode(_component_RouterLink, { to: "/my-characters" }, {
            default: _withCtx(() => [
              _createTextVNode("Characters")
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, { to: "/my-parties" }, {
            default: _withCtx(() => [
              _createTextVNode("Parties")
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, { to: "/tier-list" }, {
            default: _withCtx(() => [
              _createTextVNode("Tier list")
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})